import React from 'react'

const TranscriptEditorSpanPlayed: React.FC = ({ children }) => (
  <span className="transcript-editor-span transcript-editor-span__played">{children}</span>
)

export default TranscriptEditorSpanPlayed
